<template>
	<div class="header">
		<div class="headerBox">
			<div class="logo"><img src="../../assets/images/logo.svg" /></div>
			<div class="menu">
				<div class="nav_more"><span class="icon-bar top"></span> <span class="icon-bar middle"></span><span class="icon-bar bottom"></span></div>
				<div class="menuDown">
					<ul>
						<li v-for="(item,index) in menuData" :class="(active==index)?'activeLi':''" @click="menuFun(index,item)">{{item.name}}</li>
					</ul>
				</div>
			</div>
			<div class="headerBtn" @click="goToLogin">养老云平台溢彩版</div>
		</div>
	</div>
</template>

<script>
	import ApiSetting from '../../assets/js/interface'
	
	export default {
		name: 'Header',
		props: [],
		data() {
			return {
				active: 0,
				menuImg: '',
				menuH: 0,
				menuData: [{
						name: '首页',
						'link': '/'
					},
					{
						name: '产品介绍',
						'link': '/product'
					},
//					{
//						name: '案例',
//						'link': '/case'
//					},
				]
			};
		},
		components: {},
		mounted() {
		},
		watch: {

		},
		computed: {

		},
		created() {
			let activeS = sessionStorage.getItem('active');
			if(activeS) {
				this.active = activeS;
			}
		},
		methods: {
			menuFun: function(index, item) {
				this.active = index;
				sessionStorage.setItem('active', index);
				this.$router.push({
					path: item.link,
				});
			},
			goToLogin(){
				window.location.href='/login';
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '../../assets/css/common';
</style>


// WEBPACK FOOTER //
// src/components/public/Header.vue